import React, {Component} from "react";
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import UsTaxesList from "./views/UsTaxesList";

class UsTaxesPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleChangeSetting = this.handleChangeSetting.bind(this);
    this.state = {
      stateCode: "",
      hasSelection: false,
      selectedItem: null
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    return (
      <div className="UsTaxesPage SecurePage">
        <AppSidebar />
        <PageHeader title="Us Tax Settings" />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton
              label="Change Setting"
              active={this.state.hasSelection}
              onClick={this.handleChangeSetting}
              />

          </PanelGroupController>
        </div>
      </div>
    )
  }

  renderView(page) {
    switch(page) {
      default:
        return <UsTaxesList
                  key="UsTaxesList"
                  selectedId={this.state.stateCode} 
                  onSelectionChange={this.handleSetSelection}
                  />
    }
  }

  renderPanels(page) {
    switch(page) {
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      default:
        return null;      
    }
  }

  handleSetSelection(item) {
    this.setState({
      stateCode: item.get("stateCode"), 
      hasSelection: true,
      selectedItem: item
    });
  }

  handleChangeSetting() {
    this.props.requestChangeUsTaxSetting(this.state.selectedItem.get("stateCode"), this.state.selectedItem.get("name"));
  }

}

export default UsTaxesPage;